"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'settings.socialMedia.column.platform': '平台',
    'settings.socialMedia.column.status': '状态',
    'settings.socialMedia.x.title': 'X (Twitter)',
    'settings.socialMedia.x.description': '连接您的 X 账号以发布内容。',
    'settings.socialMedia.x.connect': '连接 X',
    'settings.socialMedia.x.disconnect': '断开 X',
    'settings.socialMedia.x.disconnected': 'X 已断开',
    'settings.socialMedia.x.connectFailed': 'X 连接失败',
    'settings.socialMedia.x.disconnectFailed': 'X 断开失败',
    'settings.socialMedia.ig.title': 'Instagram',
    'settings.socialMedia.ig.description': '连接您的 Instagram 商业账号以发布内容。',
    'settings.socialMedia.ig.connect': '连接 Instagram',
    'settings.socialMedia.ig.disconnect': '断开 Instagram',
    'settings.socialMedia.ig.disconnected': 'Instagram 已断开',
    'settings.socialMedia.ig.connectFailed': 'Instagram 连接失败',
    'settings.socialMedia.ig.disconnectFailed': 'Instagram 断开失败',
    'settings.socialMedia.fb.title': 'Facebook',
    'settings.socialMedia.fb.description': '连接您的 Facebook 账号以发布内容。',
    'settings.socialMedia.fb.connect': '连接 Facebook',
    'settings.socialMedia.fb.disconnect': '断开 Facebook',
    'settings.socialMedia.fb.disconnected': 'Facebook 已断开',
    'settings.socialMedia.fb.connectFailed': 'Facebook 连接失败',
    'settings.socialMedia.fb.disconnectFailed': 'Facebook 断开失败',
    'settings.socialMedia.yt.title': 'YouTube',
    'settings.socialMedia.yt.description': '连接您的 YouTube 频道以发布视频。',
    'settings.socialMedia.yt.connect': '连接 YouTube',
    'settings.socialMedia.yt.disconnect': '断开 YouTube',
    'settings.socialMedia.yt.disconnected': 'YouTube 已断开',
    'settings.socialMedia.yt.connectFailed': 'YouTube 连接失败',
    'settings.socialMedia.yt.disconnectFailed': 'YouTube 断开失败',
    'settings.socialMedia.tt.title': 'TikTok',
    'settings.socialMedia.tt.description': '连接您的 TikTok 账号以发布视频。',
    'settings.socialMedia.tt.connect': '连接 TikTok',
    'settings.socialMedia.tt.disconnect': '断开 TikTok',
    'settings.socialMedia.tt.disconnected': 'TikTok 已断开',
    'settings.socialMedia.tt.connectFailed': 'TikTok 连接失败',
    'settings.socialMedia.tt.disconnectFailed': 'TikTok 断开失败',
    'settings.socialMedia.li.title': 'LinkedIn',
    'settings.socialMedia.li.description': '连接您的 LinkedIn 账号以发布内容。',
    'settings.socialMedia.li.connect': '连接 LinkedIn',
    'settings.socialMedia.li.disconnect': '断开 LinkedIn',
    'settings.socialMedia.li.disconnected': 'LinkedIn 已断开',
    'settings.socialMedia.li.connectFailed': 'LinkedIn 连接失败',
    'settings.socialMedia.li.disconnectFailed': 'LinkedIn 断开失败',
    'settings.socialMedia.pt.title': 'Pinterest',
    'settings.socialMedia.pt.description': '连接您的 Pinterest 帐户以发布 Pin。',
    'settings.socialMedia.pt.connect': '连接 Pinterest',
    'settings.socialMedia.pt.disconnect': '断开 Pinterest',
    'settings.socialMedia.pt.disconnected': 'Pinterest 已断开',
    'settings.socialMedia.pt.connectFailed': '连接 Pinterest 失败',
    'settings.socialMedia.pt.disconnectFailed': '断开 Pinterest 失败',
    'settings.socialMedia.th.title': 'Threads',
    'settings.socialMedia.th.description': '连接您的 Threads 帐户以发布内容。',
    'settings.socialMedia.th.connect': '连接 Threads',
    'settings.socialMedia.th.disconnect': '断开 Threads',
    'settings.socialMedia.th.disconnected': 'Threads 已断开',
    'settings.socialMedia.th.connectFailed': '连接 Threads 失败',
    'settings.socialMedia.th.disconnectFailed': '断开 Threads 失败',
    'settings.socialMedia.dictionary.title': '社交媒体字典',
    'settings.socialMedia.dictionary.type': '类型',
    'settings.socialMedia.dictionary.type.tone': '语气',
    'settings.socialMedia.dictionary.type.goal': '目标',
    'settings.socialMedia.dictionary.type.audience': '受众',
    'settings.socialMedia.dictionary.key': '键',
    'settings.socialMedia.dictionary.label': '标签',
    'settings.socialMedia.dictionary.icon': '图标',
    'settings.socialMedia.dictionary.order': '排序',
    'settings.socialMedia.dictionary.active': '活跃',
    'settings.socialMedia.dictionary.add': '添加',
    'settings.socialMedia.dictionary.edit': '编辑',
    'settings.socialMedia.dictionary.delete': '删除',
    'settings.socialMedia.dictionary.editTitle': '编辑字典项',
    'settings.socialMedia.dictionary.addTitle': '添加字典项',
    'settings.socialMedia.dictionary.save': '保存',
    'settings.socialMedia.dictionary.cancel': '取消',
    'settings.socialMedia.dictionary.loadFailed': '加载字典失败',
    'settings.socialMedia.dictionary.fillRequired': '请填写必填字段',
    'settings.socialMedia.dictionary.saved': '字典项已保存',
    'settings.socialMedia.dictionary.saveFailed': '保存字典项失败',
    'settings.socialMedia.dictionary.deleted': '字典项已删除',
    'settings.socialMedia.dictionary.deleteFailed': '删除字典项失败',
    'settings.socialMedia.dictionary.deleteConfirm': '确定要删除此字典项吗？',
    'settings.socialMedia.dictionary.actions': '操作',
};
